<div class="col-12">
    <div id="filter-tag-job-form" class="filter-tags-ctn filter-tags-ctn-desktop filter-tags-ctn-mobile form-group"
        *ngIf="jobSearchForm">

        <filter-tag-checkbox-multi [controlArray]="jobSearchForm.optionPosition" [label]="'Cargo'"
            [dataSelectLabel]="jobSearchForm.POSITION_LIST"></filter-tag-checkbox-multi>

        <filter-tag-checkbox-multi *ngIf="showCategory" [controlArray]="jobSearchForm.optionCategory" [label]="'Categoría'"
            [dataSelectLabel]="jobSearchForm.POSITION_CATEGORY_LIST"></filter-tag-checkbox-multi>

        <filter-tag-text [control]="jobSearchForm.optionFilter" [title]="'Filtro'"
            (eventResetControl)="jobSearchForm.onActionSearch()"></filter-tag-text>


        <filter-tag-checkbox-multi [controlArray]="jobSearchForm.optionLevel" [label]="'Ciclo'"
            [dataSelectLabel]="jobSearchForm.LEVEL_LIST"></filter-tag-checkbox-multi>

        <filter-tag-checkbox-multi *ngIf="jobSearchForm.countAddressSelected < 3"
            [controlArray]="jobSearchForm.optionAddress3" [label]="'Comuna'"
            [dataSelectLabel]="jobSearchForm.ADDRESS3_LIST"></filter-tag-checkbox-multi>

        <div *ngIf="jobSearchForm.countAddressSelected >= 3" class="filter-tag">Comunas:
            {{jobSearchForm.countAddressSelected}}
            seleccionadas
            <a (click)="jobSearchForm.resetOptionAddress();" class="remove" title="Eliminar">×</a>
        </div>

        <filter-tag-checkbox [control]="jobSearchForm.optionNextSeason"
            [title]="'Solo cargos 2026'"></filter-tag-checkbox>

            <div [class.d-none]="jobSearchForm.countFilterTag === 0" class="text-center order-1">
            <button class="btn btn-link btn-sm font-weight-bold" type="button"
                (click)="jobSearchForm.onClickResetButton($event)">Limpiar
                filtros</button>
        </div>
    </div>
</div>